import type { PromotionRequest } from "../api/types";

const STATE_CLASS: Record<PromotionRequest["state"], string> = {
    queued: "grey",
    pipeline_running: "blue",
    mr_open: "yellow",
    merged: "green",
    failed: "red",
    cancelled: "grey",
    stuck: "red",
};

export default function MrChip({ promotion }: { promotion: PromotionRequest }) {
    const url = promotion.mr?.webUrl ?? promotion.pipeline?.webUrl;
    const label = promotion.mr ? `MR !${promotion.mr.iid}` : promotion.pipeline ? `pipeline #${promotion.pipeline.id}` : "promotion";
    const target = promotion.toVersion ?? promotion.requestedVersion ?? "upstream";
    const title = `${promotion.fromVersion ?? "?"} → ${target} · requested by ${promotion.requestedBy}${promotion.error ? ` · ${promotion.error}` : ""}`;
    const chip = (
        <span className={`mr-chip ${STATE_CLASS[promotion.state]}`} title={title}>
            {label} · {promotion.outcome ?? promotion.state.replace(/_/g, " ")}
        </span>
    );
    if (!url) return chip;
    return (
        <a href={url} target="_blank" rel="noopener noreferrer">
            {chip}
        </a>
    );
}
